module.exports = __webpack_public_path__ + "assets/media/5.fc3dfe8f.wav";